/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface CompositionProductVariantSummary {
  brandEquity?: number;
  brandId?: number;
  brandName?: string;
  category?: string;
  categoryExternalId?: number;
  categoryExternalIdString?: string;
  categoryId?: number;
  categoryLevel?: number;
  categoryName?: string;
  cean?: string;
  cfop?: string;
  compositionId?: number;
  compositionName?: string;
  costPrice?: number;
  cst?: string;
  dateCreated?: Date;
  dateUpdated?: Date;
  defaultImageURL?: string;
  editionId?: number;
  expiration?: string;
  externalId?: number;
  extipi?: string;
  genero?: string;
  inStockAcquisition?: number;
  inStockFidelization?: number;
  inStockInfluencerB4A?: number;
  inStockReserveMarketing?: number;
  internalEAN?: string;
  invoicePrice?: number;
  isSellableUrl?: boolean;
  ncm?: string;
  orderCount?: number;
  productId?: number;
  productVariantId?: number;
  productVariantName?: string;
  quantity?: number;
  salePrice?: number;
  sellable?: boolean;
  subscriptionId?: number;
  subscriptionName?: string;
  tradeActive?: boolean;
  tradeCount?: number;
  tradePoints?: number;
  tradeable?: boolean;
  weight?: number;
}
